<script lang="ts">
  import { worldStore } from '@sim/store';
  import { currentGoal } from '@sim/progress';
  import { activeBuilding } from '@sim/world';

  $: city = $worldStore;
  $: goal = currentGoal(city);
  $: b = activeBuilding(city)!;
</script>

{#if goal}
  <div class="banner">
    <div class="line">
      <span class="g">🎯 {goal.label}</span>
      <span class="prog mono">{b.colonists.length}/{b.maxCrew} crew · {city.buildings.length} 🏢</span>
    </div>
    <div class="hint">{goal.hint}</div>
  </div>
{/if}

<style>
  .banner {
    padding: 7px 10px;
    background: #14141d;
    border-top: 1px solid var(--line);
  }
  .line {
    display: flex;
    align-items: baseline;
    gap: 8px;
  }
  .g {
    font-size: 12.5px;
    font-weight: 700;
    color: var(--ink);
  }
  .prog {
    margin-left: auto;
    font-size: 10px;
    color: var(--ink-faint);
  }
  .hint {
    font-size: 10.5px;
    color: var(--ink-dim);
  }
</style>
